module.exports = __webpack_public_path__ + "static/img/p2.79ec457.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/law/p2.jpg
// module id = VTC4
// module chunks = 12